// extracted by mini-css-extract-plugin
var _1 = "FormAdditionalFields-modulefieldsContainer__opLwV FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "fieldsContainer" }
